<template>
  <section class="hbox stretch">
    <div class="content-header">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item><a href="/">营销</a></el-breadcrumb-item>
        <el-breadcrumb-item>优惠券</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="content-main">
      <el-form :inline="true">
        <el-form-item>
          <el-button type="primary" class="el-icon-circle-plus-outline" v-on:click="AddCoupon" >新增</el-button>
        </el-form-item>         
        <el-form-item >
          <el-input  placeholder="消息名称" v-model="name"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" v-on:click="Search" >查询</el-button>
        </el-form-item>
      </el-form>
      <el-table :data="coupons" style="width: 100%">
        <el-table-column  prop="Name" fixed="left" label="名称"> </el-table-column>
        <el-table-column  prop="Value"  label="金额"> </el-table-column>
        <el-table-column  prop="ConsumeValue"  label="消费满使用"> </el-table-column>
        <el-table-column  prop="Price"  label="售价"> </el-table-column>
        <el-table-column  prop="TotalNumber"  label="总数量"> </el-table-column>
        <el-table-column  prop="MemberLimitNumber"  label="单人限制数量" ></el-table-column>
        <el-table-column  prop="ReceiveNumber"  label="发放数量" ></el-table-column>
        <el-table-column  prop="UsedNumber"  label="使用数量" ></el-table-column>
        <el-table-column  prop="CreateTime"  label="创建时间" :formatter="dateFormat"> </el-table-column>
        <el-table-column  fixed="right" label="操作" width="120">
        <template slot-scope="scope">
          <el-button @click.native.prevent="editcoupon(scope.row.Id)" type="text" size="small">
            编辑
          </el-button>
          <el-button  @click="DeleteRow(scope.row.Id)" type="text" size="small">&nbsp; 删除 </el-button>
        </template>
      </el-table-column>
      </el-table>
      <el-pagination
        :hide-on-single-page="true"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="pageIndex"
        :page-sizes="[10, 20, 30, 50]"
        :page-size="pagesize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="totalCount">
      </el-pagination>
    </div>   
  </section>
</template>
<script  type='text/ecmascript-6'>
  export default {
    props:{
    },
    data (){
      return {
        name:'',
        pageIndex:1,
        pagesize:10,
        totalCount:10,
        sort:' CreateTime desc',
        coupons:[]
      }
    },
    computed:{
    },
    mounted(){
      this.CouponQuery();
    },
    methods:{     
      Search:function(){
        this.pageIndex = 1;
        this.ChainStoreQuery();
      },
      AddCoupon:function(){
        this.$router.push({
          name:'couponInfo',
          params:{
            Id:''
          }
        })
      },
      CouponQuery:function(){
        var that = this
        this.axios({
          method:'get',
          url:that.global.serverSrc + '/api/Coupon/Index',
          params:{
            name : that.name,
            pageIndex : that.pageIndex,
            pagesize : that.pagesize,
            sort : that.sort
          }
        }).then(function (resp) {
          that.totalCount = resp.data.totalCount
          that.coupons = resp.data.coupons
        }).catch(resp => {
          console.log('请求失败：' + resp.message + ',' + resp.stack)
        })
      },
      dateFormat:function(row, column, cellValue, index){
        let data = row[column.property]
	      return  /\d{4}-\d{1,2}-\d{1,2}/g.exec(data )
      },
      editcoupon(id){
        this.$router.push({
          name:'couponInfo',
          params:{
            Id:id
          }
        })
      },
      DeleteRow(id) {
        this.$confirm('确定要删除该优惠券吗?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          var that = this
          this.axios({
            method:'post',
            url:that.global.serverSrc + '/api/Coupon/Delete',
            data:{
              id: id
            }
          }).then(function (resp) {  
            if(resp.data.errorCode==0){              
              that.$message.success(resp.data.message);
              that.GetUserRoleData();
            }else {              
              that.$message.warning(resp.data.message);
            }
          }).catch(resp => {
            console.log('请求失败：' + resp.message + ',' + resp.stack)
          })
        }).catch(() => {
            
        });
      },
      handleSizeChange(val) {
        console.log(`每页 ${val} 条`);
      },
      handleCurrentChange(val) {
        console.log(`当前页: ${val}`);
      }
    },
    components:{    
       
    },
    created(){
    
    },
  }
</script>
<style lang='stylus' rel='stylesheet/stylus'>
.content-header
  padding 24px
  border 1px solid #C0C4CC
.content-main
  padding 24px  
</style>